import { Outlet } from "react-router-dom"
import Navigate from "../components/shared/Navigate";
import ContractInfoPage from "../pages/ContractInfoPage";
import useAuth from "../hooks/useAuth";
import { roleOptions } from "../utils/appRoles";

const PrivateRoutes = ({accessList = Object.values(roleOptions)}) => {
    const {auth} = useAuth();    
    const userType = auth?.user?.type;
    const hasContractInfo = auth?.user?.has_contract;
    const previousUrl = window.location.pathname + window.location.search;

    if (!auth?.accessToken){
        return <Navigate to="/login" replace state={{previousUrl}}/>
    }

    if (userType === roleOptions.EMPLOYEE && !hasContractInfo) {
        return <ContractInfoPage/>;
    }

    if (accessList.includes(userType)) {        
        return (<Outlet />);
    }

    return <Navigate to="/pagenotfound" replace/>
}

export default PrivateRoutes;